// src/utils/pushSubscription.js
import { supabase } from '../supabaseClient';

export function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

/**
 * Checks if the browser subscription is present in the database.
 */
export async function verifyDeviceSyncWithDatabase(userId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { synced: false, error: 'Unsupported environment' };
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      return { synced: false, subscription: null, reason: 'No local subscription token found.' };
    }

    const { data, error } = await supabase
      .from('user_push_subscriptions')
      .select('id')
      .eq('user_id', userId)
      .eq('endpoint', subscription.endpoint)
      .maybeSingle();

    if (error) throw error;

    if (!data) {
      return { synced: false, subscription, reason: 'Stale client token. Missing in database.' };
    }

    return { synced: true, subscription };
  } catch (error) {
    console.error('❌ Sync verification error:', error);
    return { synced: false, subscription: null, error };
  }
}